import {useEffect, useState} from 'react'
import {useMsal} from '@azure/msal-react'
import {adobeConfig, silentRequest} from './authConfig'
import {Card, Container, Spinner} from 'react-bootstrap'
import skfLogo from '../Assets/SKF-Logo.png'
import {CircularProgressbar, buildStyles} from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'

export const ApplicationRole = (props: any) => {
  const {instance, accounts} = useMsal()
  const [accessToken, setAccessToken] = useState('')
  const [secondsLeft, setSecondsLeft] = useState<number | null>(null)
  const [totalDuration, setTotalDuration] = useState<number>(0)
  const [loading, setLoading] = useState(true)

  // eslint-disable-next-line
  useEffect(() => {
    if (!accessToken) {
      fetchAccessToken()
    }
    // eslint-disable-next-line
  }, [])

  // Fetch access token
  const fetchAccessToken = async () => {
    if (accessToken) return
    try {
      const userProfile = await instance.acquireTokenSilent(silentRequest)
      setAccessToken(userProfile.accessToken)
      await fetchApplicationRole(userProfile.accessToken, (userProfile.account?.idTokenClaims?.email as string) || '')
    } catch (error) {
      console.error('Token error:', error)
    } finally {
    }
  }

  // Fetch application roles
  const fetchApplicationRole = async (token: string, email: string) => {
    try {
      const rolesResponse = await fetch(`${process.env.REACT_APP_GET_APPLICATION_ROLE_URL}`, {
        headers: {Authorization: `Bearer ${token}`},
      })

      if (rolesResponse.ok) {
        const data = await rolesResponse.json()
        const studentRoleData = data.roles?.find((r: any) => r.roleName === process.env.REACT_APP_STUDENT_ROLE)

        if (studentRoleData) {
          console.log(studentRoleData)
          // await checkAcpInfo(token, email)
          window.location.href = adobeConfig.loginUrl
        } else {
          await getAutoApproveRoles(token)
          // await checkAcpInfo(token, email)
          setSecondsLeft(360)
          setTotalDuration(360)
          setLoading(false)
        }
      }
    } catch (error) {
      console.error('Roles fetch error:', error)
    }
  }

  // Check ACP info
  // const checkAcpInfo = async (token: string, email: string) => {
  //   try {
  //     const response = await fetch(`${process.env.REACT_APP_CHECK_USER}`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Authorization: `Bearer ${token}`,
  //       },
  //       body: JSON.stringify({user_role: 'admin', email, account_type: 'prod'}),
  //     })

  //     const data = await response.json()
  //     if (data.success) {
  //       window.location.href = adobeConfig.loginUrl
  //       return
  //     } else {
  //       setSecondsLeft(360)
  //       setTotalDuration(360)
  //       setLoading(false)
  //     }
  //     return data
  //   } catch (error) {
  //     console.error(error)
  //     return {success: false}
  //   }
  // }

  // Auto-approve roles
  const getAutoApproveRoles = async (token: string) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_ROLE_AUTO_APPROVE_URL}requests?role=${process.env.REACT_APP_STUDENT_ROLE}`,
        {
          method: 'POST',
          headers: {Authorization: `Bearer ${token}`},
        }
      )

      if (response.ok) {
        const data = await response.json()
        console.log(data)
      }
    } catch (error) {
      console.error('Auto-approve error:', error)
    }
  }

  // Timer effect
  useEffect(() => {
    if (secondsLeft === null) return

    const timer = setTimeout(() => {
      setSecondsLeft(prev => {
        if (prev === 0) {
          window.location.href = adobeConfig.loginUrl
          return null
        }
        return prev ? prev - 1 : null
      })
    }, 500)

    return () => clearTimeout(timer)
  }, [secondsLeft])

  return (
    <>
      <Container>
        {/* image here */}
        <div className="text-center">
          <img src={skfLogo} alt="SKF Academy Logo" style={{maxWidth: '150px', marginTop: '1rem'}} />
        </div>
        <h4 style={{textAlign: 'center', fontWeight: 'bold'}} className="p-3">
          Welcome {accounts[0]?.name} !!
        </h4>
        {loading && (
          <Card className="p-4 shadow-lg rounded-4">
            <Card.Body className="text-center">
              <Card.Title>Checking your credentials. Please wait...</Card.Title>
              <Spinner
                animation="border"
                variant="primary"
                style={{
                  width: '60px',
                  height: '60px',
                  borderWidth: '8px',
                }}
                className="my-3"
              />
            </Card.Body>
          </Card>
        )}
        {!loading && (
          <Card className="p-4 shadow-lg rounded-4">
            <Card.Body className="text-center">
              <Card.Title>You will soon have access to SKF Academy</Card.Title>
              <div style={{width: 100, height: 100, margin: '0 auto'}} className="my-4">
                <CircularProgressbar
                  value={
                    totalDuration > 0 && secondsLeft !== null
                      ? Math.round(100 - (100 * secondsLeft) / totalDuration)
                      : 0
                  }
                  text={`${
                    totalDuration > 0 && secondsLeft !== null
                      ? Math.round(100 - (100 * secondsLeft) / totalDuration)
                      : 0
                  }%`}
                  styles={buildStyles({
                    textSize: '16px',
                    pathColor: '#0e58d6',
                    textColor: '#0e58d6',
                    trailColor: '#d6d6d6',
                  })}
                />
              </div>
              <Card.Text>
                We are setting up your learning experience in the SKF Academy. Bear with us, this could take up to 3
                min. Thanks for your patience.
              </Card.Text>
            </Card.Body>
          </Card>
        )}
      </Container>
    </>
  )
}
